<template>
  <section class="damage-claim mt-10">
    <v-container class="mx-auto">
      <v-row
        no-gutters
        class="justify-lg-space-between align-center justify-center"
      >
        <v-col
          cols="12"
          sm="8"
          lg="5"
          class="damage-claim--img d-flex justify-center align-center mb-16"
        >
          <v-col cols="10" sm="9">
            <div class="damage-claim--img--content">
              <div v-for="(content, i) in leftContent" :key="i">
                <span><i :class="content.iconClass"></i></span
                ><span>{{ content.text }}</span>
              </div>
            </div>
          </v-col>
        </v-col>
        <v-col
          cols="10"
          sm="8"
          lg="5"
          class="damage-claim--content mt-15 mt-lg-0"
        >
          <p class="damage-claim--content--slogan">{{ rightContent.slogan }}</p>
          <h2 class="damage-claim--content--title">{{ rightContent.title }}</h2>
          <p class="damage-claim--content--desc">
            {{ rightContent.desc }}
          </p>
          <!-- Servis bağlanana kadar pasife alındı -->
          <!--<v-btn :ripple="false" text class="damage-claim--content--btn">
            Hasar Talebinde Bulun
          </v-btn>-->
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      leftContent: [
        {
          iconClass: 'fas fa-tasks fa-2x',
          text: 'Bize durumunuzdan kısaca bahsedin'
        },
        {
          iconClass: 'fas fa-envelope-open-text fa-2x',
          text: 'İletişim bilgilerinizi iletin'
        },
        {
          iconClass: 'fas fa-phone-alt fa-2x',
          text: 'Sizinle iletişime geçelim'
        }
      ],
      rightContent: {
        slogan: 'Doğru Fiyat, Doğru Ürün',
        title: 'Hasar Talebinde Bulunmak',
        desc:
          ' Her şey yolunda giderse, hasar talebinde bulunmanıza gerek kalmaz. Fakat sigorta poliçeniz kapsamında bir hasar meydana gelirse sizin için süreci basit ve stressiz yapıyoruz. Özellikle de tüm haklarınızı doğru bir şekilde almanız için zaman ayırmanız gerekir. Tüm bunlar etkili bir talepte bulunma sürecinden geçiriyor.'
      }
    }
  }
}
</script>

<style></style>
